/**
 * Object of Shipping Carriers
 */

export default {
  FEDEX: 'FEDEX',
  USPS: 'USPS',
  UPS: 'UPS'
};
